import { jsx as r } from "react/jsx-runtime";
import e from "./simple-wrapper.mjs";
import { twJoin as a } from "tailwind-merge";
import { isBlackContrast as m } from "../themes/utils/get-text-color-contrast.mjs";
import { useDesignContext as s } from "../providers/use-design-provider.mjs";
const c = ({ children: o }) => {
  const {
    state: { tertiaryColor: t }
  } = s();
  return /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r(
    "div",
    {
      className: a(
        "bg-THEME-secondary mx-5 rounded-lg border p-5 sm:mx-0",
        m(t) ? "shadow-around-sm border-transparent" : "border-THEME-border-tertiary"
      ),
      children: o
    }
  ) });
};
export {
  c as default
};
